<template>
    <div>
      <section class="summaryIndexPage">
        <div class="mainView">
          <div class="introduce">
            <div class="intro-word1">天工智码SKYCODE</div>
            <div class="intro-word2">AI智能编程助手 轻松生成各种代码</div>
            <div class="intro-word3">Code faster and better</div>
            <div class="tryBtnView">
              <el-button class="btn sureBtn linearBtnBg" @click="loginBtn">开始试用</el-button>
              <!-- 定位二维码 -->
              <div class="erweimaBg tw-flex tw-flex-col tw-items-center">
                  <img src="../../../../static/images/SkyCode.jpeg" alt="">
                  <div class="title font10px">微信扫码加入技术交流群</div>
              </div>
            </div>
            <div class="exampleCodeBg tw-flex tw-justify-center">
              <v-domeCode ref="domeCodeChild" v-if="demoList.length" :demoListPor="demoList"></v-domeCode>
            </div>
          </div>
          <div class="characteristicMain tw-flex">
            <div class="characteristicMainLi">
              <img src="../../../../static/images/characteristic-img-1.png">
              <div>
                <div class="title">简单易用</div>
                <div class="intro">SkyCode作为编辑器扩展提供服务，可以无缝融入到您的开发环境。</div>
              </div>
            </div>
            <div class="characteristicMainLi">
              <img src="../../../../static/images/characteristic-img-2.png">
              <div>
                <div class="title">提升工作效率</div>
                <div class="intro">节省开发时间，清晰直观的操作页面，一键快速生成您想要的代码，几乎不需要花时间学习。</div>
              </div>
            </div>
            <div class="characteristicMainLi">
              <img src="../../../../static/images/characteristic-img-3.png">
              <div>
                <div class="title">人工智能驱动</div>
                <div class="intro">SkyCode由SingularityAI自研的大模型提供支持，在GPT-3 13B基础上进行微调后重新训练，是国内最优秀的代码补全模型。</div>
              </div>
            </div>
          </div>
          <div class="multLanguageView">
            <div class="title">随时随地的编辑器AI助手</div>
            <div class="intro">天工SkyCode可以直接集成到您的编辑器中，无缝衔接在您的开发环境，在您键入代码的同时，智能高效补全代码，提升工作效率，节省开发时间。目前我们已经集成在了 Visual Studio Code 中，后续会支持更多平台和工具，如 Neovim、JetBrains IDE、Visual Studio 等，目前还在测试阶段...</div>
            <div class="multLanguageViewDetail tw-flex">
              <div v-for="(i, index) in 4" :key="index" class="multLanguageViewLiBg tw-flex tw-justify-center tw-items-center">
                <div class="multLanguageViewLi tw-flex tw-items-center">
                  <img :src="require('../../../../static/images/editor-type' + i + '.png')" />
                  <div class="name" :class="i != 1 && 'nonsupport-name'">{{i==1?'VS Code':i==2?'Visual Studio':i==3?'Neovim':i==4?'JetBrains IDEs':''}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-footer></v-footer>
      </section>
      <v-backtopBtn v-if="backtopBtnShow" @fatherSetTop="fatherSetTop"></v-backtopBtn>
      <!-- <el-backtop target=".summaryIndexPage" :right="120" :bottom="100">
          <img class="backtopImg" src="../../../../static/images/back-top-icon.png" />
      </el-backtop> -->
      
    </div>
</template>

<script>
import {getCookiesData} from '../../../utils/common'
import vFooter from '../../../components/footerDiv'
import vDomeCode from '../../../components/domeCode'
import vBacktopBtn from '../../../components/backtopBtn'
export default {
    name: 'SummaryIndex',
    components: {
      vFooter,
      vDomeCode,
      vBacktopBtn
    },
    data() {
        return {
            backtopBtnShow: false,
            demoList: []
        };
    },
    created() {
      this.$emit('isNavClick', '1')
      this.$actionBuryPointWay('','home-page','open','')
      this.getdemoListData()
    },
    mounted() {
      //mounted监听滚动
      window.addEventListener('scroll', this.handleScroll, true)
    },
    methods: {
      getdemoListData() {
        let that = this
        that.$get(that.$axiosUrl.demoList, {})
        .then((response) => {
          console.log(response)
          this.demoList= response.resp_data.code_demo_list
          for(let i= 0; i < this.demoList.length; i++) {
            let indexNumber = this.demoList[i].code_input.lastIndexOf("\n",this.demoList[i].code_input.lastIndexOf("\n"));
            console.log(indexNumber);
            this.demoList[i].showTopContent = this.demoList[i].code_input.substring(0,indexNumber).split('\n');
          }
        })
      },
      // 置顶函数
      fatherSetTop() {
        /* 定时器，缓慢置顶*/      
        var time = setInterval(function(){
        /* top为距离页面顶部距离*/
            let top = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
            /* 每次走的距离*/
            let step = Math.ceil(top/10);
            /* 滚动位置*/
            window.scroll(0,top-step);
            /* 到达顶部清除定时器*/
            if(top==0){
                clearInterval(time);
            }
        },10)
      },
      //监听窗口滚动
      handleScroll() {
        //如果获取不到高度可换成 
          if (document.querySelector('.characteristicMain')) {
            this.$nextTick(()=>{
                var scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
                let contentScrollWrap = document.querySelector('.characteristicMain').offsetTop - 100; // 减去间距
                console.log(scrollTop, contentScrollWrap);
                if (scrollTop > contentScrollWrap) {
                  if(this.backtopBtnShow == false){this.backtopBtnShow = true}
                }else {
                  if(this.backtopBtnShow == true){this.backtopBtnShow = false}
                }
            })
          }
      },
      loginBtn () {
        // this.$actionBuryPointWay('','home-page','《开始试用》按钮点击','')
        console.log(getCookiesData('skyCodeUserBaseInfo'));
        if (getCookiesData('skyCodeUserBaseInfo')) { // 看是否登录
          this.$router.push({path: '/documentIndex'})
        } else {
        this.$emit('isShowLoginPopupClick', true, '/documentIndex')
        }
      },
    },
    destroyed() {
      //离开页面时删除该监听
      window.removeEventListener('scroll', this.windowScrollListener)
    }
};
</script>

<style scoped lang="less">
.summaryIndexPage {
  padding-bottom: 80px;
  padding-top: 117px;
  margin: 0 auto;
  background: #060714;
  overflow-y: scroll;
  overflow-x: hidden;
  // height: 100vh;
  min-width: 1200px;
  .mainView {
    // width: 100vw;
    background: url('../../../../static/images/home-center-bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    .introduce {
      text-align: center;
      // padding-top: 194px;
      padding-top: 6.104vw;
      .intro-word1 {
        // margin-bottom: 32px;
        margin-bottom: 1.66667vw;
        font-weight: 400;
        font-size: 15px;
        line-height: 18px;
        text-align: center;
        letter-spacing: 8px;
        color: #7780A1;
      }
      .intro-word2 {
        font-weight: 700;
        font-size: 54px;
        line-height: 72px;
        text-align: center;
        color: #FFFFFF;
      }
      .intro-word3 {
        // margin: 72px auto 122px;
        margin: 3vw auto 5vw;
        font-weight: 400;
        font-size: 24px;
        line-height: 150%;
        letter-spacing: 0.2px;
        color: #7780A1;
      }
      .tryBtnView {
        position: relative;
        // margin-bottom: 90px;
        margin-bottom: 3.75vw;
        .btn {
          width: 284px;
          height: 85px;
          border: none;
          border-radius: 16px !important;
          font-size: 24px !important;
          
        }
      }
      .exampleCodeBg {
        max-width: 1200px;
        margin: 0 auto;
      }
    }
    .characteristicMain {
      // grid-template-columns: repeat(auto-fill, 383px);
      flex-flow: wrap; 
      justify-content: center;
      grid-gap: 25px;
      color: #A6ADB1;
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 1px;
      margin: 100px 0 120px 0;
      .characteristicMainLi {
        // width: 383px;
        max-width: 383px;
        width: 19.95vw;
        // height: 366px;
        border: 1px solid #262840;
        border-radius: 16px;
        padding: 20px;
        img {
          // width: 343px;
          // height: 190px;
          width: 100%;
          height: auto;
        }
        .title {
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          margin-top: 28px;
          margin-bottom: 12px;
          color: #fff;
          text-align: center;
        }
        .intro {
          padding: 0 8px;
        }
      }
    }
    .multLanguageView {
      .title {
        text-align: center;
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;
        letter-spacing: 1px;
        color: #EFF5FA;
        margin-bottom: 72px;
      }
      .intro {
        // max-width: 1300px;
        max-width: 67.708vw;
        // padding: 0 50px;
        margin: 0 auto 80px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 1px;
        color: #FFFFFF;
      }
      .multLanguageViewDetail {
        // grid-template-columns: repeat(auto-fill, 284px);
        flex-flow: wrap; 
        justify-content: center;
        grid-gap: 24px;
        margin-bottom: 140px;
        .multLanguageViewLiBg {
          // width: 284px;
          // height: 284px;
          max-width: 284px;
          max-height: 284px;
          width: 14.7917vw;
          height: 14.7917vw;
          border-radius: 16px;
          background: linear-gradient(7.96deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0) 93.86%), #060714;
        }
      }
      .multLanguageViewLi {
        flex-direction: column;
        justify-content: center;
        // width: 282px;
        // height: 282px;
        max-width: 282px;
        max-height: 282px;
        width: 14.6875vw;
        height: 14.6875vw;
        background: linear-gradient(187.96deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0) 93.86%), #060714;
        // border: linear-gradient(to bottom #262840 0%,#262840 100%);
        border-radius: 16px;
        // padding-top: 66px;
        padding-top: 10px;
        color: #fff;
        img {
          // width: 130px;
          // height: 130px;
          width: 46.1%;
          // height: 130px;
          margin-bottom: 22px;
        }
        .name {
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          letter-spacing: 1px;
          color: #FFFFFF;
        }
        .nonsupport-name {
          opacity: 0.6;
        }
      }
    }
    
  }
  .erweimaBg {
    position: absolute;
    right: 80px;
    top: 50%;
    margin-top: -70px;
    width: 130px;
    height: 140px;
    border: 1px solid #262840;
    border-radius: 4px;
    .title {
      white-space: nowrap;
      text-align: center;
      color: #FFF;
      font-weight: 400;
      line-height: 12px;
      margin-top: 10px;
      padding-left: 35px;
    }
    img {
      margin-top: 16px;
      width: 90px;
      height: 90px;
    }
  }

}
.summaryIndexPage::-webkit-scrollbar { width: 0 !important }
.summaryIndexPage { -ms-overflow-style: none; }
.summaryIndexPage { overflow: -moz-scrollbars-none; }

.el-backtop {
  width: 100px;
  height: 100px;
  background-color: transparent;
 .backtopImg {
    width: 100px;
    height: 100px;
  }
}
</style>

